import React from 'react'
import { Link, useRouteMatch } from 'react-router-dom'
import { Card, Hyperlink, Heading, LazyImage, Text } from '@offerzen/pinata'

import styles from './styles'

const EmptyListCard = () => {
  const match = useRouteMatch()
  const { candidateSlug } = match.params

  return (
    <div role="status">
      <Card className={styles.wrapper}>
        <LazyImage loader={() => import('@/assets/cat-with-magnifying-glass.svg')} alt="" width={210} />

        <Heading>
          <strong>Jobs you have applied to will appear here.</strong>
        </Heading>

        <Text>
          <p>
            Send applications by visiting{' '}
            <Hyperlink label="Recommended jobs" href={`/candidate/${candidateSlug}/recommended-jobs`} as={Link} />.
          </p>
        </Text>
      </Card>
    </div>
  )
}

export default EmptyListCard
